// extracted by mini-css-extract-plugin
export default {"linksBlock":"public-api__linksBlock___dySoG","publicApiLinks":"public-api__publicApiLinks___lWMcW","link":"public-api__link___lQOqG","active":"public-api__active___r_gaI"};